import React, { useState, useEffect } from 'react';
import { Typography} from '@mui/material'
import Grid from '@mui/material/Grid';
import MDTextField from './MDTextField';
import AsyncReactSelect from './AsyncReactSelect';
import { validate} from '../../service/AddressValidation'

function Address(props) {
  const [address, setAddress] = useState(props.address);
  const [summary, setSummary] = useState(props.summary);
  const [index, setIndex] = useState(props.index);
  const [reviewPage, setReviewPage] = useState(props.reviewPage);
  const [thirdpartylocator, setThirdpartylocator] = useState(props.thirdpartylocator);
  const [sameAddress, setSameAddress] = useState(props.sameAddress);
  const [inUnitedStates, setInUnitedStates] = useState(props.inUnitedStates);
  const [uniqId, setSameuniqId] = useState(props.uniqId);

  const [livinginUS, setLivinginUS] = useState(true);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [filter, setFilter] = useState('');
  const [filterCountry, setFilterCountry] = useState('');
  const [filterCity, setFilterCity] = useState('');
  const [addressValid, setAddressValid] = useState(false);
  const [addressValidation, setAddressValidation] = useState(false);
  const [addressValidationMessage, setAddressValidationMessage] = useState('');

  const [requiredFields, setRequiredFields] = useState({streetName: props.reviewPage? true : false, city: props.reviewPage? true : false, 
                    populateZip:'', othercity:props.reviewPage? true:false, state: true, zip: true, country: props.reviewPage? true : false});

  const { locator } = props
  
  useEffect(() => {
    setAddress(props.address)
  }, [props.address])
  useEffect(() => {
    setSummary(props.summary)
  }, [props.summary])
  useEffect(() => {
    setFilter(props.filter)
  }, [])
  useEffect(() => {
    setInUnitedStates(props.inUnitedStates)
  }, [props.inUnitedStates])

  const handleChange = (propertyName, value) => {
     let newFilterCountry = address.country !== null ? address.country.value : ""
    let newAddress = {
      ...address,
      [propertyName]: value,         
    };
    
    let USZipcodes = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
    let zipcode = newAddress.zip.match(USZipcodes)? newAddress.zip : setError(true); setErrorText('Incorrect US Zip Code Format')
    
    if (newAddress.country !== null && newAddress.country.value !== null && newAddress.country.value !== undefined && 
        newAddress.country.value === 'USA' && newAddress.zip!=='' && newAddress.zip !== zipcode) {  
      setError(true)
      setErrorText('Incorrect US Zip Code Format')
    } else {
      setError(false)
      setErrorText('')
    }

    if (propertyName === 'country' && value !== null) {
      newAddress = {
        ...newAddress,
        state: '',
        city: ''
      }
      setFilter(value.value)
    }
    if (propertyName === 'state' && value !== null) {
      newAddress = {
        ...newAddress,        
        city: ''
      }
      setFilterCity(value.value)
    }
   
    if(propertyName === 'city' && value !==null && newAddress.city!==undefined && newAddress.city.value !== 'OTHER') {        
             newAddress.othercity='' ;    
    } 
    setAddress(newAddress)
    setFilterCountry(newFilterCountry)
    props.updateAddress(newAddress, index)
  }


  const handleError = (propertyName, error) => { 
    var allReqDone = false;

    const newRequiredFields = {
      ...requiredFields,
      [propertyName]: !error,      
    };

    setRequiredFields(newRequiredFields)

    if (newRequiredFields.streetName && newRequiredFields.city && newRequiredFields.state &&
        // (this.props.inUnitedStates || filterCountry !== ''? true : newRequiredFields.country)) { 
        (props.inUnitedStates? true : newRequiredFields.country)) { 
          if(address.city.value!=='OTHER') {               
             allReqDone = true; 
          } else if(address.city.value==='OTHER' && newRequiredFields.othercity) {
            allReqDone = true;
          }  
            const parsedAddress = validate(address)         
            parsedAddress.then( result => {
              // console.log('validresult ' + JSON.stringify(result))
              if (result !== undefined && result !== null && result.addresses !== undefined && result.addresses[0] !== null) {
                if (result.addresses[0].address_parser_match_level === '1') {
                  setAddressValid(false)
                  setAddressValidation(true)
                  setAddressValidationMessage('City/Province not valid')                 
                } else if (result.addresses[0].address_parser_match_level === '2') {
                  setAddressValid(false)
                  setAddressValidation(true)
                  setAddressValidationMessage('Street Name not valid')                    
                } else if (result.addresses[0].address_parser_match_level === '3') {
                  setAddressValid(false)
                  setAddressValidation(true)
                  setAddressValidationMessage('House Number Range  not valid')                    
                } else if (result.addresses[0].address_parser_match_level === '4') {
                  setAddressValid(false)
                  setAddressValidation(true)
                  setAddressValidationMessage('Street Component not valid')                    
                } else if (result.addresses[0].address_parser_match_level === '0' || result.addresses[0].address_parser_match_level === '5'
                              || result.addresses[0].address_parser_match_level === '6') {
                  // const newAddress = {
                  //   ...address,
                  //   zip: result.addresses[0].zip,      
                  // };
                  // setAddress(newAddress)
                  address.zip = result.addresses[0].zip;
                  setAddressValid(true)
                  setAddressValidation(true)
                  setAddressValidationMessage('Valid')   
                  // this.state.address.zip= result.addresses[0].zip;
                } else {
                  setAddressValidation(false)
                  setAddressValidationMessage('')              
                }
              }
            })          
    }
  // console.log("add req " + filterCountry + ' ' + JSON.stringify(newRequiredFields) + ' address'+index + ' ' + allReqDone) 
    props.handleError('address'+index, allReqDone);
  }

    // const { address, summary, error, errorText, filter, filterCountry, filterCity, addressValid, addressValidation, addressValidationMessage, index} = this.state
    // const { classes, inUnitedStates,locator, thirdpartylocator } = this.props
  return (
    <div>
        {addressValidation && 
        <Grid container sx={{ flexDirection: 'row', justifyContent: "flex-end", alignItems: "center"}}>
          <Typography sx={addressValid ? {
            paddingLeft: '15px',
            paddingRight: '15px',
            fontSize: '0.875rem',
            textAlign:'center',
            color: '#ffffff',
            backgroundColor: '#0f9c41',
            fontWeight: '550',
            height: '20px',
            borderRadius: '1rem',
          } : {
            paddingLeft: '5px',
            paddingRight: '5px',
            fontSize: '0.75rem',
            textAlign:'center',
            color: '#ffffff',
            backgroundColor: '#6b6b6b',
            fontWeight: '550',
            height: '20px',
            borderRadius: '1rem',
          }}>Address Check: {addressValidationMessage}</Typography>              
        </Grid>
        }
        <Grid container sx={{ flexDirection: 'row', alignItems: "center"}}>                  
          <MDTextField key='streetName' name='streetName'  label='Address' value={address.streetName} 
                handleChange={handleChange} handleError={handleError} required={true}  wide={true} 
                  inputProps={{maxLength: 100, id:locator === 'Review'? 'streetname' + index+locator : 'streetname' + index}} summary={summary} />
        </Grid>
        <Grid container sx={{ flexDirection: 'row', alignItems: "center"}}>
          <AsyncReactSelect name='country' label='Country' value={address.country} placeholder='Search for Country' filterCountry={filterCountry} errorText='Please select country' 
              optionsType='country' handleChange={handleChange} handleError={handleError} required={true}  uniqId={locator === 'Review'? 'Country' + index + locator : 'Country' + index}
              disabled={summary? true : false} summary={summary} />                       

            {(address.country === null || (address.country.value !== 'USA' && address.country.value !== 'CAN' && address.country.value !== 'MEX')) &&
            <MDTextField name='state' label='State/Province' value={address.state} handleChange={handleChange} handleError={handleError}
            inputProps={{maxLength: 2, id:locator === 'Review'? 'state' + index+locator : 'state' + index}}
              required={false} disabled={summary? true : false} summary={summary} /> 
            }
            {address.country !== null && (address.country.value === 'USA' || address.country.value === 'CAN' || address.country.value === 'MEX') &&
            <AsyncReactSelect name='state' label='State/Province' value={address.state} inUnitedStates={inUnitedStates} filter={filter} placeholder='Search for State' errorText='Please select State' 
                optionsType='state' handleChange={handleChange} handleError={handleError} required={false} uniqId={locator === 'Review'? 'State' + locator :thirdpartylocator ==='thirdparty'?'State' + thirdpartylocator: 'State'}
                disabled={summary? true : false}  summary={summary} />
          } 

          {(address.country === null || address.country.value !== 'USA' || address.state.value === null) &&
          <MDTextField name='city' label='City' value={address.city} handleChange={handleChange} handleError={handleError} required={true} disabled={summary? true : false}
            inputProps={{maxLength: 60, id:locator === 'Review'? 'city' + index+locator: 'city' + index}} summary={summary} /> 
          }
          {address.country !== null && address.country.value === 'USA' && address.state.value !== null &&
          <AsyncReactSelect name='city' label='City' value={address.city} placeholder='Search for City' inUnitedStates={inUnitedStates} filterCity={filterCity} errorText='Please select city' 
              optionsType='city'  handleChange={handleChange} handleError={handleError} required={true} uniqId = {locator === 'Review'? 'City' + locator:'City'} 
              disabled={summary? true : false} summary={summary} />
          }        
          
          <MDTextField name='zip' label='Zip or Postal Code' value={address.zip} handleChange={handleChange} handleError={handleError} 
              error={error} errorText={errorText} required={false} disabled={summary? true : false} inputProps={{maxLength: 20,id:locator==='Review'?'zip'+index+locator:'zip'+index}} summary={summary} />            
        </Grid> 

        {address.city.value==="OTHER" && 
          <Grid container sx={{ flexDirection: 'row', alignItems: "center", marginLeft:'417px' }}>
            <MDTextField name='othercity' label='Other City' value={address.othercity}    handleChange={handleChange} handleError={handleError} required={true} disabled={summary? true : false}
            inputProps={{maxLength: 60, id:locator === 'Review'? 'othercity' + index+locator: 'othercity' + index}} summary={summary} />  
          </Grid>
}                  
    </div>
  );
}

export default Address;